var map = {
	"./auth.json": "../../packages/i18n/src/fr_FR/auth.json",
	"./banners.json": "../../packages/i18n/src/fr_FR/banners.json",
	"./business-meta.json": "../../packages/i18n/src/fr_FR/business-meta.json",
	"./chat/common.json": "../../packages/i18n/src/fr_FR/chat/common.json",
	"./chat/list.json": "../../packages/i18n/src/fr_FR/chat/list.json",
	"./chat/message.json": "../../packages/i18n/src/fr_FR/chat/message.json",
	"./company/admin.json": "../../packages/i18n/src/fr_FR/company/admin.json",
	"./company/common.json": "../../packages/i18n/src/fr_FR/company/common.json",
	"./company/create.json": "../../packages/i18n/src/fr_FR/company/create.json",
	"./company/options.json": "../../packages/i18n/src/fr_FR/company/options.json",
	"./company/page.json": "../../packages/i18n/src/fr_FR/company/page.json",
	"./company/users.json": "../../packages/i18n/src/fr_FR/company/users.json",
	"./errors.json": "../../packages/i18n/src/fr_FR/errors.json",
	"./group-preview.json": "../../packages/i18n/src/fr_FR/group-preview.json",
	"./landing/companies.json": "../../packages/i18n/src/fr_FR/landing/companies.json",
	"./landing/driver.json": "../../packages/i18n/src/fr_FR/landing/driver.json",
	"./landing/exchange.json": "../../packages/i18n/src/fr_FR/landing/exchange.json",
	"./landing/meta.json": "../../packages/i18n/src/fr_FR/landing/meta.json",
	"./landing/private_exchange.json": "../../packages/i18n/src/fr_FR/landing/private_exchange.json",
	"./landing/shared.json": "../../packages/i18n/src/fr_FR/landing/shared.json",
	"./layout.json": "../../packages/i18n/src/fr_FR/layout.json",
	"./modals.json": "../../packages/i18n/src/fr_FR/modals.json",
	"./offer/actions.json": "../../packages/i18n/src/fr_FR/offer/actions.json",
	"./offer/exchange.json": "../../packages/i18n/src/fr_FR/offer/exchange.json",
	"./offer/form/cargo.json": "../../packages/i18n/src/fr_FR/offer/form/cargo.json",
	"./offer/form/common.json": "../../packages/i18n/src/fr_FR/offer/form/common.json",
	"./offer/form/options.json": "../../packages/i18n/src/fr_FR/offer/form/options.json",
	"./offer/form/transport.json": "../../packages/i18n/src/fr_FR/offer/form/transport.json",
	"./offer/matches.json": "../../packages/i18n/src/fr_FR/offer/matches.json",
	"./offer/my.json": "../../packages/i18n/src/fr_FR/offer/my.json",
	"./offer/own.json": "../../packages/i18n/src/fr_FR/offer/own.json",
	"./offer/preview.json": "../../packages/i18n/src/fr_FR/offer/preview.json",
	"./offer/shared.json": "../../packages/i18n/src/fr_FR/offer/shared.json",
	"./offer/view.json": "../../packages/i18n/src/fr_FR/offer/view.json",
	"./placeholders.json": "../../packages/i18n/src/fr_FR/placeholders.json",
	"./profile/black_list.json": "../../packages/i18n/src/fr_FR/profile/black_list.json",
	"./profile/contact_list.json": "../../packages/i18n/src/fr_FR/profile/contact_list.json",
	"./profile/edit_profile.json": "../../packages/i18n/src/fr_FR/profile/edit_profile.json",
	"./profile/fill_profile.json": "../../packages/i18n/src/fr_FR/profile/fill_profile.json",
	"./profile/my_profile.json": "../../packages/i18n/src/fr_FR/profile/my_profile.json",
	"./profile/my_profile_auth.json": "../../packages/i18n/src/fr_FR/profile/my_profile_auth.json",
	"./profile/profile_form.json": "../../packages/i18n/src/fr_FR/profile/profile_form.json",
	"./profile/shared.json": "../../packages/i18n/src/fr_FR/profile/shared.json",
	"./profile/short_profile.json": "../../packages/i18n/src/fr_FR/profile/short_profile.json",
	"./shared.json": "../../packages/i18n/src/fr_FR/shared.json",
	"./ui.json": "../../packages/i18n/src/fr_FR/ui.json",
	"./validation.json": "../../packages/i18n/src/fr_FR/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../packages/i18n/src/fr_FR sync recursive \\.json$";